import Card from 'components/Card';
import styled from 'styled-components';

const TableCardContainer = styled(Card)`
  min-height: 60%;
  display: flex;
`;

export default TableCardContainer;
